// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { ComponentButtonFragmentDoc } from '../../../components/cms/component/content/ContentButton.fragment.generated';
import { ImageMediumFragmentDoc } from '../../../components/cms/imageMedium.fragment.generated';
export const Banner2FragmentDoc = gql`
    fragment banner2 on Banner2 {
  backgroundColor
  preTitle
  title
  text
  button {
    ...componentButton
  }
  image {
    ...imageMedium
  }
}
    ${ComponentButtonFragmentDoc}
${ImageMediumFragmentDoc}`;